import { Entity } from '@/interfaces'
import model from './model'
import repository from './repository'

const ratioBookingDiscountEntity: Entity = {
  model: model,
  repository: repository,
}

export default ratioBookingDiscountEntity
